<kui-modal #modal size="lg" [title]="data?.title || ('SHARED.MAP.LOCATION_SELECT.TITLE' | translate)" [actions]="modalActions" (onClose)="detachModal()">
    <div class="d-flex flex-1 p-3 flex-column">
        <p class="description">
            {{ "SHARED.MAP.LOCATION_SELECT.DESC" | translate }}
        </p>

        <key-form-builder [form]="form" [values]="values" autoTranslatePrefix="SHARED.MAP.LOCATION_SELECT"> </key-form-builder>

        <div class="search">
            <kui-input-group [cleanAddons]="true">
                <input
                    kui-input
                    #searchInput
                    type="text"
                    [placeholder]="'SHARED.SEARCH_ELLIPSES' | translate"
                    [ngModel]="searchValue"
                    (ngModelChange)="debouncedUpdateSearchValue($event)"
                    (focus)="!!searchValue && (showSearchResults = true)"
                />
                @if (!loading && !searchValue) {
                    <kui-icon kui-input-group-addon name="search" [size]="1"></kui-icon>
                }
                @if (!loading && !!searchValue) {
                    <kui-icon kui-input-group-addon kui-action name="close" (click)="clearSearch()" [size]="1"></kui-icon>
                }
                @if (loading) {
                    <kui-loader kui-input-group-addon size="small"></kui-loader>
                }
            </kui-input-group>
            @if (showSearchResults) {
                <kui-card>
                    <kui-card-body [class.text-center]="loading">
                        @if (loading) {
                            <kui-loader size="small"></kui-loader>
                        }
                        @if (!loading && !searchResults?.length) {
                            <div>{{ "LEAFLET.NO_RESULTS" | translate }}</div>
                        }
                        @if (!loading && searchResults?.length) {
                            <key-search-results-list
                                [list]="searchResults"
                                [highlightValue]="searchValue"
                                (onBlur)="blurSearchInput()"
                                (onSelected)="updateValues($event?.meta)"
                            ></key-search-results-list>
                        }
                    </kui-card-body>
                </kui-card>
            }
        </div>

        <key-leaflet-map
            #map
            class="w-100"
            [controls]="mapControls"
            (onMarkerAdded)="updateValues($event.coordinates, $event.id)"
            (onCoordinatesSelected)="updateValues($event)"
        ></key-leaflet-map>
    </div>
</kui-modal>
